import { render, staticRenderFns } from "./RequisitionOptions.vue?vue&type=template&id=60be0dca&scoped=true&"
import script from "./RequisitionOptions.vue?vue&type=script&lang=js&"
export * from "./RequisitionOptions.vue?vue&type=script&lang=js&"
import style0 from "./RequisitionOptions.vue?vue&type=style&index=0&id=60be0dca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60be0dca",
  null
  
)

export default component.exports